import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';

import Logo from '../../components/Logo';
const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  }
}));

const TopBar = ({ className, onMobileNavOpen, onDesktopNavToggle, ...rest }) => {
  const classes = useStyles();
  const [notifications] = useState([]);

  const logut = () => {
    localStorage.removeItem('user_id');
    localStorage.removeItem('tipo_usuario');
    localStorage.removeItem('nombres');
    localStorage.removeItem('tipousuario_id');
  };

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar>
        <Hidden mdDown>
          <IconButton color="inherit" onClick={onDesktopNavToggle} edge="start">
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/app/dashboard">
          <Logo />
        </RouterLink>
        <Box flexGrow={1} />
        <Hidden mdDown>
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              {/* <NotificationsIcon /> */}
            </Badge>
          </IconButton>
          <IconButton color="inherit">
            <RouterLink
              to="/"
              alt="Salir"
              title="Salir"
              style={{ color: 'white' }}
              onClick={logut}
            >
              <InputIcon />
            </RouterLink>
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
  onDesktopNavToggle: PropTypes.func
};

export default TopBar;
